<template>
  <layout>
    <section class="title-bar">
      <div class="columns">
        <div class="column">
          <h1 v-if="isSelfFeedback">
            Self Feedback - {{ $page.props.auth.user.first_name }}
            {{ $page.props.auth.user.last_name }}
          </h1>
          <h1 v-else>
            Feedback for {{ participant.first_name }}
            {{ participant.last_name }}
          </h1>
          <b-progress
            :value="Math.floor((stepCount / (steps.length - 1)) * 100)"
            show-value
            format="percent"
          ></b-progress>
          <hr />
        </div>
      </div>
    </section>

    <span ref="questionBoxAnchor"></span>
    <section class="questions">
      <div class="columns">
        <div class="column">
          <div v-for="(step, index) in steps" :key="step.name">
            <div v-if="stepCount == index">
              <div v-if="step.type == 'intro'" class="intro-text block">
                <div class="box" v-html="step.content"></div>
              </div>

              <div v-if="step.type == 'sucessdriver'">
                <div class="box">
                  <div class="successDriverTitle">
                    <h2>{{ step.successDriver.name }}</h2>
                    <p>{{ step.successDriver.description }}</p>
                  </div>

                  <div class="number-explanation-box">
                    <h3>Scores</h3>
                    <p
                      v-for="(
                        questionDescription, index
                      ) in questionDescriptions"
                      :key="questionDescription.id"
                      class="score"
                    >
                      {{ questionDescription.order + 1 }} -
                      {{ questionDescription.name }}
                    </p>
                  </div>

                  <div
                    v-for="question in step.questions"
                    :key="question.unique_id"
                  >
                    <p>{{ question.title }}</p>

                    <div
                      v-if="question.type == 'radio'"
                      class="radio question-box"
                    >
                      <h3>{{ question.name }}</h3>
                      <div
                        v-for="(
                          questionDescription, index
                        ) in questionDescriptions"
                        :key="questionDescription.id"
                      >
                        <b-radio
                          v-model="question.answer"
                          :name="question.unique_id"
                          lazy
                          @input="UpdateAnswer(question)"
                          :native-value="index + 1"
                        >
                          {{ questionDescription.order + 1 }} -
                          {{ questionDescription.name }}
                        </b-radio>
                      </div>
                    </div>

                    <div
                      v-if="question.type == 'slider'"
                      class="slider question-box"
                    >
                      <h3>{{ question.name }}</h3>
                      <div class="block">
                        <b-field>
                          <b-slider
                            :min="0"
                            :max="questionDescriptions.length"
                            :tooltip="false"
                            size="is-medium"
                            v-model="question.answer"
                            lazy
                            @input="UpdateSliderAnswer(question)"
                            :id="question.unique_id"
                          >
                            <template
                              v-for="(
                                questionDescription, index
                              ) in questionDescriptions"
                            >
                              <b-slider-tick
                                :value="index + 1"
                                :key="index + 1"
                                >{{ index + 1 }}</b-slider-tick
                              >
                            </template>
                          </b-slider>
                        </b-field>
                        <br />
                        <div v-if="!isSelfFeedback" class="field ml-2">
                          <b-checkbox
                            @input="UpdateCheckbox(question)"
                            v-model="question.is_seen"
                            :true-value="false"
                            :false-value="true"
                            >Not Seen</b-checkbox
                          >
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="question.type == 'text'"
                      class="text question-box"
                    >
                      <h3>{{ question.name }}</h3>
                      <div class="block">
                        <b-field>
                          <b-input
                            maxlength="50000"
                            type="textarea"
                            v-model="question.answer"
                            @blur="UpdateTextAnswer(question)"
                          ></b-input>
                        </b-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="step.type == 'successDriverRanking'">
                <div class="box">
                  <div class="successDriverTitle">
                    <!-- wording for self feedback -->
                    <span v-if="isSelfFeedback">
                      <h2>
                        Please now rank the success drivers in order of their
                        relative importance to your current role
                      </h2>
                      <p>
                        Where should you be focusing your time and energy? Note
                        that 1 is the MOST important, 2 is the next important
                        etc
                      </p>
                    </span>
                    <!-- wording when giving feedback to others -->
                    <span v-else>
                      <h2>
                        Please now rank the success drivers in order of their
                        relative importance to your colleague’s current role
                      </h2>
                      <p>
                        Where should they be focusing their time and energy Note
                        that 1 is the MOST important, 2 is the next important
                        etc
                      </p>
                    </span>
                  </div>
                  <div class="columns successDriverRankingBoxes">
                    <div class="column">
                      <div
                        v-if="showUnorderedBox"
                        id="unorderedBox"
                        class="orderingBox"
                      >
                        <draggable
                          class="list-group"
                          tag="div"
                          v-model="step.unorderedSuccessDrivers"
                          v-bind="dragOptions"
                          @start="isDragging = true"
                          @end="isDragging = false"
                        >
                          <transition-group
                            type="transition"
                            :name="'flip-list'"
                          >
                            <div
                              class="successDriver"
                              v-for="driver in step.unorderedSuccessDrivers"
                              :key="driver.unique_id"
                            >
                              {{ driver.name }}
                            </div>
                          </transition-group>
                        </draggable>
                      </div>
                    </div>
                    <div class="column">
                      <div id="orderedBox" class="orderingBox">
                        <draggable
                          element="span"
                          v-model="step.orderedSuccessDrivers"
                          v-bind="dragOptions"
                          :moved="
                            updateSuccessDriverRanking(
                              step.orderedSuccessDrivers
                            )
                          "
                        >
                          <transition-group
                            name="no"
                            class="list-group"
                            tag="div"
                          >
                            <div
                              class="successDriver"
                              v-for="(
                                driver, index
                              ) in step.orderedSuccessDrivers"
                              :key="driver.unique_id"
                            >
                              {{ parseInt(index) + 1 }}. {{ driver.name }}
                            </div>
                          </transition-group>
                        </draggable>
                      </div>
                    </div>
                  </div>
                  <div>
                    <b-button @click="showSuccessDriverRankingBoxesModal = true"
                      >Help</b-button
                    >
                    <b-modal v-model="showSuccessDriverRankingBoxesModal">
                      <SuccessDriverRankingHelp />
                    </b-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-mobile">
        <div class="column">
          <b-button
            type="is-info"
            v-if="
              stepName(stepCount) !== 'successDriverRanking' && !isFinalStep
            "
            @click="saveAndClose"
            >Save and close</b-button
          >
        </div>
        <div class="column text-align-center is-hidden-mobile">
          Page {{ stepCount + 1 }} / {{ steps.length }}
        </div>
        <div class="column">
          <div class="button-container">
            <b-button
              type="is-primary"
              outlined
              @click="stepCount--"
              v-if="stepCount !== 0"
              >Previous</b-button
            >
            <b-button
              type="is-primary"
              @click="stepCount++"
              :disabled="!canProgress"
              v-if="!isFinalStep"
              >Next</b-button
            >
            <p v-if="!canProgress" class="mt-2 has-text-danger">
              Please answer all questions to continue
            </p>
            <b-button v-if="isFinalStep" type="is-primary" @click="finishButton"
              >Finish</b-button
            >
          </div>
        </div>
      </div>
      <div class="column text-align-center is-hidden-tablet">
        Page {{ stepCount + 1 }} / {{ steps.length }}
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';
import draggable from 'vuedraggable';
import SuccessDriverRankingHelp from '../../Components/Feedback/SuccessDriverRankingHelp';

export default {
  components: {
    Layout,
    draggable,
    SuccessDriverRankingHelp,
  },
  props: {
    project: Object,
    participant: Object,
    steps: Array,
    questionDescriptions: Array,
  },
  data() {
    return {
      editable: true,
      isDragging: false,
      delayedDragging: false,
      stepCount: 0,
      showUnorderedBox: true,
      showSuccessDriverRankingBoxesModal: false,
    };
  },
  methods: {
    UpdateTextAnswer: function (question) {
      if (question.answer.trim().length > 0) {
        this.UpdateAnswer(question);
      }
    },
    UpdateCheckbox: function (question) {
      if (question.is_seen) {
        question.answer = 1;
      } else {
        question.answer = 0;
      }
      this.UpdateAnswer(question);
    },
    UpdateSliderAnswer: function (question, event) {
      if (question.answer > 0) question.is_seen = 1;
      this.UpdateAnswer(question);
    },
    UpdateAnswer: function (question) {
      this.putData(
        route('feedback.project.updateAnswer', {
          project: this.project.unique_id,
          user: this.participant.unique_id,
          question: question.unique_id,
        }),
        {
          answer: question.answer,
          is_seen: question.is_seen,
        }
      );
    },
    updateSuccessDriverRanking: function (successDriverList) {
      this.putData(
        route('feedback.project.updateSuccessDriverRanking', {
          project: this.project.unique_id,
          participant: this.participant.unique_id,
        }),
        { successDriverList }
      );
    },
    putData: function (url, data) {
      fetch(url, {
        method: 'put',
        dataType: 'JSON',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(
          Object.assign({ _token: this.$page.props.csrf_token }, data)
        ),
      });
    },
    stepName(stepNum) {
      return this.steps[stepNum].type;
    },
    saveAndClose() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message:
          "Are you sure you want to leave? You haven't finished giving feedback yet",
        cancelText: 'Leave',
        confirmText: 'Continue Feedback',
        onCancel: () =>
          this.$inertia.get(route('feedback.project', this.project.unique_id)),
      });
    },
    finishButton() {
      console.log('current step is:');
      console.dir(this.currentStep);
      if (
        this.currentStep.type == 'successDriverRanking' &&
        this.currentStep.unorderedSuccessDrivers.length > 0
      ) {
        this.showFinalStepBox();
        return;
      }
      this.$inertia.get(route('feedback.project', this.project.unique_id));
    },
    showFinalStepBox() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message:
          "You haven't ranked your success drivers yet. Please do so before continuing.",
        cancelText: 'Leave',
        confirmText: 'Complete Success Driver Rankings',
        onCancel: () =>
          this.$inertia.get(route('feedback.project', this.project.unique_id)),
      });
    },
  },
  computed: {
    currentStep() {
      return this.steps[this.stepCount];
    },
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost',
      };
    },
    isSelfFeedback() {
      return this.participant.unique_id == this.$page.props.auth.user.id;
    },
    isFinalStep() {
      return this.stepCount == this.steps.length - 1;
    },

    // loop through the questions in the current step. If you find a question that is not filled in, return false
    // if all questions on the current step are filled in, return true
    canProgress() {
      if (this.currentStep.questions) {
        for (var i = 0; i < this.currentStep.questions.length; i++) {
          if (
            this.currentStep.questions[i].is_seen == 1 &&
            (this.currentStep.questions[i].answer == 0 ||
              this.currentStep.questions[i].answer == '' ||
              this.currentStep.questions[i].answer == null)
          )
            return false;
        }
      }
      return true;
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    stepCount(stepNum) {
      // we want to move all the unordered successdriver ranks into the ordered box when on mobile, so that there is only one box to move around
      if (
        this.stepName(stepNum) == 'successDriverRanking' &&
        window.innerWidth < 769
      ) {
        // move elements from one array to another, we need to move one by one instead of copying the array in case user is halfway through ranking already
        while (this.steps[stepNum].unorderedSuccessDrivers.length > 0) {
          this.steps[stepNum].orderedSuccessDrivers.push(
            this.steps[stepNum].unorderedSuccessDrivers[0]
          );
          this.steps[stepNum].unorderedSuccessDrivers.splice(0, 1);
        }
        // hide the unordered box
        this.showUnorderedBox = false;
      }

      // also we want to jump to the top of the question box on each new page
      let questionBoxAnchor = this.$refs['questionBoxAnchor'];
      let top = questionBoxAnchor.offsetTop;
      window.scrollTo(0, top);
    },
  },
};
</script>
